(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(scope){
    (scope || document).querySelectorAll('[data-ba]').forEach(function(el){
      if(el.dataset.baReady) return;
      el.dataset.baReady = '1';
      var media = el.querySelector('.ba-media');
      var range = el.querySelector('[data-ba-range]');
      if(!media || !range) return;
      function set(v){ media.style.setProperty('--pos', v + '%'); }
      range.addEventListener('input', function(){ set(range.value); });
      set(range.value);
    });
  }
  init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
